import { Pipe, PipeTransform } from '@angular/core';

/**
 * LinkParsePipe
 * --------------
 * Purpose:
 *   Normalize arbitrary CMS strings into absolute app paths for routing.
 *
 * Behavior:
 *   - Empty/null/undefined → "/"
 *   - Explicit schemes (http, https, mailto, tel, ftp, data, …) → returned unchanged
 *   - Everything else → internal path normalized to exactly one leading slash
 *       e.g. "zomer" -> "/zomer", "///zomer" -> "/zomer", "//cdn.example.com/x" -> "/cdn.example.com/x"
 *
 * Notes:
 *   - Only use this for internal navigation if you're binding to [routerLink].
 *     Passing external URLs (e.g. "https://…") to [routerLink] will not work.
 *     For external links, bind to [href] instead.
 */
@Pipe({
	name: 'linkparse',
	pure: true,
	standalone: true,
})
export class LinkParsePipe implements PipeTransform {
	transform(value?: string | null): string {
		const raw = (value ?? '').trim();
		if (!raw) {
			return '/';
		}

		// Keep explicit schemes unchanged (http, https, mailto, tel, ftp, data, etc.)
		if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) {
			return raw;
		}

		// Internal path: ensure exactly one leading slash
		return '/' + raw.replace(/^\/+/, '');
	}
}
